import SectionHeading from './SectionHeading';

const STEPS = [
  {
    icon: 'ri-bookmark-line',
    title: '选征集令，或直接求料',
    desc: '在征集令墙找到对口方向点进去；如果还没人征集你手里的料，选择“求料”，说清你想找什么。',
  },
  {
    icon: 'ri-ball-pen-line',
    title: '写清时间、地点与证据',
    desc: '越是具体的时间节点、平台入口、对象名称和手头已有截图，越容易被核实采用。说不清的细节可以先标注“待补充”。',
  },
  {
    icon: 'ri-focus-3-line',
    title: '收回执，围观扫核过程',
    desc: '提交后 24–72 小时内你会收到含编号的回执；进入求证的线索会在工作台公开更新状态，你可以持续围观、补充。',
  },
];

const PROMISES = [
  ['称呼与邮箱均可选填', '不需要暴露真实身份，也能提供关键线索。'],
  ['内容先脱敏再公开', '线索进入核实前会抹去可指向你个人的信息。'],
  ['敏感材料单独接收', '截图、录音等有专人对接的安全合规渠道。'],
  ['每条都有编号回执', '可凭编号查询状态，也可按需撤回线索。'],
];

export default function HowItWorks() {
  return (
    <section id="steps" className="border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          index="04"
          kicker="提供方式"
          title="三步，把料交到能求证的人手上"
          sub="不复杂的流程，才能让更多隐藏的线索浮出来。从选择方向到拿到回执，全程透明可追踪。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* timeline steps */}
          <div className="lg:col-span-7">
            <ol className="relative space-y-0">
              {STEPS.map((s, i) => (
                <li key={s.title} className="relative flex gap-5 pb-9 last:pb-0">
                  {i < STEPS.length - 1 && (
                    <span
                      className="absolute left-[22px] top-12 h-[calc(100%-3rem)] w-px bg-background-300"
                      aria-hidden="true"
                    ></span>
                  )}
                  <span className="relative z-10 flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 border-primary-200 bg-background-50">
                    <i className={'text-lg text-primary-600 ' + s.icon} aria-hidden="true"></i>
                  </span>
                  <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 md:pl-8">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="flex h-7 w-9 items-center justify-center rounded-sm bg-foreground-950 font-heading text-sm font-black text-foreground-50">
                        {String(i + 1).padStart(2, '0')}
                      </span>
                      <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{s.title}</h3>
                    </div>
                    <p className="mt-3 text-[14px] leading-relaxed text-foreground-600 md:text-[15px]">{s.desc}</p>
                  </div>
                </li>
              ))}
            </ol>

            <a
              href="#submit"
              className="mt-8 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-[15px] font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line" aria-hidden="true"></i>
              现在提供线索 / 求料
            </a>
          </div>

          {/* promise card */}
          <aside className="lg:col-span-5">
            <div className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="editorial-rule h-1.5" aria-hidden="true"></div>
              <div className="flex-1 p-6 md:p-7">
                <h3 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
                  <i className="ri-shield-star-line text-primary-600" aria-hidden="true"></i>
                  我们怎么保护你
                </h3>
                <p className="mt-2 text-[14px] text-foreground-600">
                  爆料不是越勇越好，而是越安全越好。下面是寻料站对每一位线索提供者的承诺。
                </p>
                <ul className="mt-6 space-y-4">
                  {PROMISES.map(([t, d]) => (
                    <li key={t} className="flex gap-3">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
                        <i className="ri-check-line text-sm" aria-hidden="true"></i>
                      </span>
                      <div>
                        <p className="text-[14px] font-semibold text-foreground-900">{t}</p>
                        <p className="mt-0.5 text-[13px] text-foreground-600">{d}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="border-t border-background-200 bg-background-100/70 px-6 py-4 md:px-7">
                <p className="flex items-start gap-2 text-[12px] leading-relaxed text-foreground-600">
                  <i className="ri-information-line mt-0.5 shrink-0 text-primary-600" aria-hidden="true"></i>
                  本站为线索中转与求证展示平台，不对事件作权威定性；涉及纠纷请通过正规渠道反映。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}